import React from 'react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_stone-temple-preview/artifacts/63q9xahz_Official%20STP%20Logo%20STP%20Blue.png';

const Logo = ({ className = '', mono = false, size = 'default' }) => {
  const heights = { small: 'h-14', default: 'h-20 md:h-24', large: 'h-28 md:h-32' };
  const h = heights[size] || heights.default;
  return (
    <div className={`flex items-center ${className}`}>
      <img
        src={LOGO_URL}
        alt="Stone Temple Partners"
        className={`${h} w-auto object-contain ${mono ? 'logo-mono' : ''}`}
        style={mono ? { filter: 'brightness(0) invert(1)' } : undefined}
      />
    </div>
  );
};

export default Logo;
